const SaasParameters = () => import("@/views/companiesAndTerritories/partners/SaasParameters.vue")

const routes = [
    {
        path: "/admin/saas-parameters",
        name: "saasParameters",
        component: SaasParameters,
        meta: {
            label: "SaaS Parameters"
        }
    }
]

export default routes
